<script>
export default {
	name: 'SPVCheckIndex',
	computed: {
		isGoRole() {
			const user = this.$store.getters._getUserObject
			const roleName = user && user.role && user.role.name
			return ['go', 'go_manager', 'go_check'].includes(roleName)
		},
	},
	methods: {
		printProtocol() {
			window.print()
		},
	},
}
</script>

<template>
	<div class="wrap__content">
		<div class="container">
			<div class="row">
				<div class="col-xl-2 col-lg-3">
					<v-sidebar :active="['SPVCheck']"></v-sidebar>
				</div>
				<div class="col-xl-10 col-lg-9">
					<div class="content-wrapper">
						<div class="card__content">
							<div class="card__content-header">
								<div class="content__title">
									<div class="content__title--element">
										<div class="content__title--text">
											{{
												$route.name === 'SpvCheckTirPermissions'
													? $t('spv_check.title')
													: $t('titles.spv_check_history')
											}}
										</div>
									</div>
								</div>
							</div>
							<div class="card__content--body">
								<div class="flex justify-between items-center gap-4 mb-6">
									<div class="spv-tabs">
										<router-link
											:to="{ name: 'SpvCheckTirPermissions' }"
											class="spv-tab"
											:class="{
												'spv-tab--active': $route.name === 'SpvCheckTirPermissions',
											}"
										>
											{{ $t(`labels.spv_check`) }}
										</router-link>
										<router-link
											:to="{ name: 'SpvCheckTirHistory' }"
											class="spv-tab"
											:class="{
												'spv-tab--active': $route.name === 'SpvCheckTirHistory',
											}"
										>
											{{ $t(`labels.history`) }}</router-link
										>
										<router-link
											v-if="isGoRole"
											:to="{ name: 'SpvCheckTirComparison' }"
											class="spv-tab"
											:class="{
												'spv-tab--active': $route.name === 'SpvCheckTirComparison',
											}"
										>
											{{ $t(`labels.comparison`) }}</router-link
										>
									</div>

									<a
										:href="`/pdf/instructions-spv-${$i18n.locale}.pdf`"
										target="_blank"
										class="inline-flex gap-[10px] items-center text-[#52A5FC] hover:no-underline"
									>
										<svg viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:class="'w-[24px] h-[24px]'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M19.58 5.85l-5.94-3.43c-.97-.56-2.17-.56-3.15 0L4.56 5.85a3.15 3.15 0 00-1.57 2.73v6.84c0 1.12.6 2.16 1.57 2.73l5.94 3.43c.97.56 2.17.56 3.15 0l5.94-3.43a3.15 3.15 0 001.57-2.73V8.58a3.192 3.192 0 00-1.58-2.73zm-8.26 1.9c0-.41.34-.75.75-.75s.75.34.75.75V13c0 .41-.34.75-.75.75s-.75-.34-.75-.75V7.75zm1.67 8.88c-.05.12-.12.23-.21.33a.99.99 0 01-1.09.21c-.13-.05-.23-.12-.33-.21-.09-.1-.16-.21-.22-.33a.986.986 0 01-.07-.38c0-.26.1-.52.29-.71.1-.09.2-.16.33-.21.37-.16.81-.07 1.09.21.09.1.16.2.21.33.05.12.08.25.08.38s-.03.26-.08.38z" fill="#ebe134"/></svg>
										<span>{{ $t(`labels.instruction`) }}</span>
									</a>
								</div>
								<router-view></router-view>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
/* Табы — сегмент-контрол из редизайна */
.spv-tabs {
	display: inline-flex;
	gap: 4px;
	padding: 4px;
	border-radius: 10px;
	background: #eef4fb;
}

.spv-tab {
	display: inline-flex;
	align-items: center;
	height: 36px;
	padding: 0 18px;
	border-radius: 8px;
	font-size: 13px;
	font-weight: 500;
	color: #1e6fd9;
	text-decoration: none;
	transition: background 0.2s ease;
}

.spv-tab:hover {
	background: #dcebfb;
	text-decoration: none;
}

.spv-tab--active,
.spv-tab--active:hover {
	background: #1e6fd9;
	color: #fff;
	font-weight: 600;
}

.content__title--actions {
	margin-left: auto;
}

.spinner-border-sm {
	width: 1rem;
	height: 1rem;
}

.mr-1 {
	margin-right: 0.25rem;
}

/* Form block styling */
.form__block {
	background: #ffffff;
	border: 1px solid #e6e8ec;
	border-radius: 8px;
	margin-bottom: 20px;
}

.form__block--title {
	padding: 16px 20px;
	border-bottom: 1px solid #e6e8ec;
	background: #d3e7fb;
	border-radius: 8px 8px 0 0;
}

.form__block--title h3,
.form__block--title h4 {
	margin: 0;
	font-size: 16px;
	font-weight: 600;
	color: #333;
}

.form__block--content {
	padding: 20px;
}

/* Form line styling */
.form__line {
	margin-bottom: 20px;
}

/* Force label above input in a column layout */
.form__line,
.form__line--left,
.form__line--right {
	display: block;
	width: 100%;
}

.form__line--left {
	margin-bottom: 8px;
}

.form__line--title {
	font-weight: 600;
	font-size: 14px;
	color: #333;
}

.form__line--right {
	width: 100%;
}

.form__line--input {
	position: relative;
}

/* Inline action button in input (search icon inside BIN field) */
.input-with-action {
	padding-right: 44px; /* space for button */
}

.input-action-btn {
	position: absolute;
	right: 6px;
	top: 50%;
	transform: translateY(-50%);
	width: 32px;
	height: 32px;
	border-radius: 6px;
	background: #d3e7fb;
	border-color: #d3e7fb;
	color: #157fee;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
}

.input-action-btn:disabled {
	background: #ffffff;
	border-color: #ffffff;
	cursor: not-allowed;
}

/* Custom select look with caret */
.select-linck {
	appearance: none;
	-webkit-appearance: none;
	-moz-appearance: none;
	background-color: #ffffff;
	background-image: none;
	padding-right: 36px;
}

.select-caret {
	position: absolute;
	right: 12px;
	top: 50%;
	width: 20px;
	height: 20px;
	pointer-events: none;
	transform: translateY(-50%);
	transition: transform 0.2s ease;
	background-color: #157fee; /* colorized like search icon */
	-webkit-mask: url('~@/assets/img/icon-arrowdown.svg') no-repeat center / contain;
	mask: url('~@/assets/img/icon-arrowdown.svg') no-repeat center / contain;
}

.select-caret.open {
	transform: translateY(-50%) rotate(180deg);
}

.form__line--input .input-linck {
	width: 100%;
	padding: 10px 16px;
	border: 1px solid #157fee;
	border-radius: 5px;
	background: #ffffff;
	font-size: 14px;
	color: #0a091d;
	transition: border-color 0.2s ease;
}

.form__line--input .input-linck:focus {
	outline: none;
	border-color: #1976d2;
	box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.2);
}

.form__line--input .input-linck:disabled {
	background: #f8f9fa;
	border-color: #d3e7fb;
	color: #6c757d;
}

.form__line--input.input--error .input-linck {
	border-color: #f3574d;
	animation: shakeError 0.6s ease-in-out;
}

.input-required {
	color: #f3574d;
	font-size: 12px;
	margin-top: 4px;
	display: none;
}

.form__line--input.input--error + .input-required {
	display: block;
}

/* Action buttons styling */
.action-buttons {
	display: flex;
	gap: 16px;
	align-items: center;
	flex-wrap: wrap;
}

.action-btn {
	border-radius: 30px;
	padding: 12px 24px;
	font-weight: 500;
	font-size: 14px;
	color: #ffffff !important;
	display: flex;
	align-items: center;
	cursor: pointer;
	text-decoration: none !important;
	outline: none;
	border: none;
	transition: all 0.2s ease;
	min-height: 44px;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	font-family: 'Montserrat', sans-serif;
	justify-content: center;
	gap: 8px;
}

.action-btn--sm {
	padding: 8px 16px;
	min-height: 36px;
	font-size: 13px;
}

.action-btn .btn-icon {
	width: 16px;
	height: 16px;
	filter: brightness(0) invert(1);
}

.action-btn:hover:not(:disabled) {
	transform: translateY(-1px);
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.action-btn:active {
	transform: translateY(0);
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.action-btn:disabled {
	background: #e0e0e0 !important;
	color: #9e9e9e !important;
	cursor: not-allowed;
	transform: none;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Button color variants */
.action-btn--primary {
	background: #2196f3;
	border: 1px solid #2196f3;
}

.action-btn--primary:hover:not(:disabled) {
	background: #1976d2;
	border-color: #1976d2;
}

.action-btn--secondary {
	background: #157fee;
	border: 1px solid #157fee;
}

.action-btn--secondary:hover:not(:disabled) {
	background: #6aabf1;
	border-color: #6aabf1;
}

.action-btn--blue {
	background: #2196f3;
	border: 1px solid #2196f3;
}

.action-btn--blue:hover:not(:disabled) {
	background: #1976d2;
	border-color: #1976d2;
}

.action-btn--green {
	background: #4caf50;
	border: 1px solid #4caf50;
}

.action-btn--green:hover:not(:disabled) {
	background: #45a049;
	border-color: #45a049;
}

.action-btn--red {
	background: #f44336;
	border: 1px solid #f44336;
}

.action-btn--red:hover:not(:disabled) {
	background: #da190b;
	border-color: #da190b;
}

/* Table styling */
.table__block--wrap {
	margin-top: 20px;
}

.table__block--content {
	overflow-x: auto;
}

.table__analytic {
	width: 100%;
	border-collapse: collapse;
	background: #ffffff;
	border-radius: 8px;
	overflow: hidden;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.table__analytic thead {
	background: #f8f9fa;
}

.table__analytic th {
	padding: 12px 16px;
	text-align: left;
	font-weight: 600;
	font-size: 14px;
	color: #333;
	border-bottom: 1px solid #e6e8ec;
}

.table__analytic td {
	padding: 12px 16px;
	font-size: 14px;
	color: #555;
	border-bottom: 1px solid #f0f0f0;
}

.table__analytic tbody tr:hover {
	background: #f8f9fa;
}

.table__analytic tbody tr:last-child td {
	border-bottom: none;
}

/* Alert styling */
.alert {
	padding: 12px 16px;
	border-radius: 6px;
	margin-bottom: 16px;
	font-size: 14px;
}

.alert-success {
	background: #d4edda;
	border: 1px solid #c3e6cb;
	color: #155724;
}

.alert-danger {
	background: #f8d7da;
	border: 1px solid #f5c6cb;
	color: #721c24;
}

.alert-warning {
	background: #fff3cd;
	border: 1px solid #ffeaa7;
	color: #856404;
}

.alert-info {
	background: #d1ecf1;
	border: 1px solid #bee5eb;
	color: #0c5460;
}

/* Badge styling */
.badge {
	display: inline-block;
	padding: 4px 8px;
	font-size: 12px;
	font-weight: 500;
	line-height: 1;
	text-align: center;
	white-space: nowrap;
	vertical-align: baseline;
	border-radius: 4px;
}

.badge-success {
	background: #28a745;
	color: #ffffff;
}

.badge-secondary {
	background: #6c757d;
	color: #ffffff;
}

.badge-warning {
	background: #ffc107;
	color: #212529;
}

/* Permit gradient card (matching provided design) */

.permit-card {
	background: linear-gradient(
		135deg,
		rgba(209, 233, 252, 0.9) 0%,
		rgba(132, 196, 255, 0.6) 60%,
		rgba(124, 192, 255, 0.4) 100%
	);
	border-radius: 16px;
	padding: 20px;
	box-shadow: 0 6px 18px rgba(20, 34, 66, 0.08);
	border: none;
}

.permit-card__header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 16px;
}

.permit-card__title {
	margin: 0;
	font-size: 20px;
	font-weight: 700;
	color: #24324a;
}

.status-pill {
	display: inline-block;
	padding: 8px 14px;
	border-radius: 999px;
	font-weight: 600;
	font-size: 14px;
	line-height: 1;
}

.status-pill--success {
	background: #0dd68a;
	color: #ffffff;
}

.status-pill--muted {
	background: #94a3b8;
	color: #ffffff;
}

.permit-card__row {
	margin-bottom: 12px;
}

.permit-card__grid {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 12px 24px;
}

.permit-card__label {
	color: #4a5568;
	font-size: 13px;
}

.permit-card__value {
	color: #1f2937;
	font-size: 16px;
}

.permit-card__value--emph {
	font-weight: 700;
}

.permit-card__extra {
	margin-top: 8px;
}

/* Amber variant and info pill used for holder card */
.permit-card--amber {
	background: linear-gradient(
		135deg,
		rgba(255, 237, 188, 0.9) 0%,
		rgba(255, 222, 173, 0.7) 60%,
		rgba(255, 213, 153, 0.5) 100%
	);
}

.info-pill {
	background: #e6f0ff;
	color: #1f2a44;
	display: inline-block;
	padding: 8px 12px;
	border-radius: 999px;
	font-weight: 600;
	font-size: 13px;
	line-height: 1;
	box-shadow: inset 0 0 0 2px rgba(255, 255, 255, 0.6);
}

/* Soft green container for result */
.permit-card--softgreen {
	background: linear-gradient(135deg, rgba(222, 255, 233, 0.9) 0%, rgba(215, 252, 240, 0.8) 100%);
}

.permit-card--softred {
	background: linear-gradient(135deg, rgba(255, 228, 228, 0.9) 0%, rgba(255, 213, 213, 0.8) 100%);
}

.permit-card--softyellow {
	background: linear-gradient(135deg, rgba(255, 248, 219, 0.9) 0%, rgba(255, 242, 191, 0.85) 100%);
}

.permit-card--softinfo {
	background: linear-gradient(135deg, rgba(233, 246, 255, 0.9) 0%, rgba(214, 238, 255, 0.8) 100%);
}

.result-pill {
	background: #06d97d;
	color: #ffffff;
	border-radius: 20px;
	padding: 16px 18px;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 12px;
}

.result-pill--success {
	background: #06d97d;
}
.result-pill--error {
	background: #f44336;
}

.result-pill__icon {
	width: 24px;
	height: 24px;
	border-radius: 50%;
	background: #ffffff;
	position: relative;
}

.result-pill__content {
	width: 100%;
	display: flex;
	align-items: center;
	gap: 8px;
}

.result-pill__icon.icon--ok::after {
	content: '';
	position: absolute;
	top: 50%;
	left: 50%;
	width: 12px;
	height: 12px;
	transform: translate(-50%, -50%);
	-webkit-mask: url('~@/assets/img/icon-check.svg') no-repeat center / contain;
	mask: url('~@/assets/img/icon-check.svg') no-repeat center / contain;
	background: #06d97d;
}

.result-pill__icon.icon--err::after {
	content: '';
	position: absolute;
	top: 50%;
	left: 50%;
	width: 12px;
	height: 12px;
	transform: translate(-50%, -50%);
	-webkit-mask: url('~@/assets/img/icon-close-w.svg') no-repeat center / contain;
	mask: url('~@/assets/img/icon-close-w.svg') no-repeat center / contain;
	background: #f44336;
}

.result-pill--warning {
	background: #ffcc00;
}

.result-pill__icon.icon--warn::after {
	content: '!';
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -58%);
	color: #b37b00;
	font-weight: 900;
	font-size: 14px;
}

.result-pill__title {
	font-weight: 700;
	font-size: 15px;
}

.result-pill__text {
	opacity: 0.95;
}

/* Utility classes */
.text-muted {
	color: #6c757d !important;
}

.text-success {
	color: #28a745 !important;
}

.text-danger {
	color: #dc3545 !important;
}

.font-weight-bold {
	font-weight: 600 !important;
}

.mt-1 {
	margin-top: 0.25rem !important;
}

.mt-3 {
	margin-top: 1rem !important;
}

.mt-4 {
	margin-top: 1.5rem !important;
}

.mb-3 {
	margin-bottom: 1rem !important;
}

.ml-2 {
	margin-left: 0.5rem !important;
}

.d-flex {
	display: flex !important;
}

.justify-content-between {
	justify-content: space-between !important;
}

.align-items-center {
	align-items: center !important;
}

/* Animation */
@keyframes shakeError {
	0%,
	100% {
		transform: translateX(0);
	}
	10%,
	30%,
	50%,
	70%,
	90% {
		transform: translateX(-2px);
	}
	20%,
	40%,
	60%,
	80% {
		transform: translateX(2px);
	}
}

/* Print styles */
@media print {
	.content__title--actions,
	.action-btn,
	.btn {
		display: none !important;
	}

	.form__block {
		border: 1px solid #000;
		break-inside: avoid;
	}

	.table__analytic {
		box-shadow: none;
		border: 1px solid #000;
	}
}
</style>
